const styles = {
  cardBorderRadius: 24,
};

export default styles;
